import React from 'react'
import { useHandler, QueryParamsObserver } from 'labguard-cdk'
import { DEFAULT_DURATION } from 'src/services'
import { NowContext } from 'src/contexts'

export default function usePeriodState() {
  const [{ from, to }, updateQueryParams] = QueryParamsObserver.useState()

  const { now } = NowContext.use()

  return [
    React.useMemo(
      () => ({
        from: from ? new Date(from) : new Date(now.getTime() - DEFAULT_DURATION),
        to: from && to && new Date(to),
      }),
      [from, to, now]
    ),
    useHandler(({ from, to }) =>
      updateQueryParams(state => ({
        ...state,
        from: from && new Date(from).toISOString(),
        to: to && new Date(to).toISOString(),
        zoomFrom: undefined,
        zoomTo: undefined,
        alarmId: undefined,
        noteId: undefined,
      }))
    ),
  ]
}
